<template>
  <div v-if="dialogVisible" class="fund-list" style="right:20%">
    <InvestCasesList
      :name="name"
      :rid="rid"
      :cases="investmentCase"
      @mark="handleMark"
      @quit="handleQuit"
      @change="handleChange"
      @close="handleClose"
    />
  </div>
</template>
<script>
import InvestCasesList from '../components/invest-cases-list'

export default {
  components: { InvestCasesList },
  data: function() {
    return {
      dialogVisible: false,
      name: '',
      rid: '',
      investmentCase: [],
    }
  },
  methods: {
    show: function(radish) {
      this.name = radish.姓名
      this.rid = radish._id
      let investmentCase = radish['投资案例'] ? radish['投资案例'].filter(tou => tou) : []
      if (radish.主管案例 && radish.主管案例.length > 0) {
        investmentCase = investmentCase.map(c => {
          if (radish.主管案例.includes(c.名称)) {
            c.isMain = true
          }
          return c
        })
      }
      this.investmentCase = investmentCase
      this.dialogVisible = true
    },
    handleMark(val) {
      this.$emit('mark', val)
    },
    handleQuit(val) {
      this.$emit('quit', val)
    },
    handleChange(val) {
      this.$emit('change', val)
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
}
</script>
